import { render, staticRenderFns } from "./my-account-setting-real-person-authentication.vue?vue&type=template&id=7d0a972e&scoped=true&"
import script from "./my-account-setting-real-person-authentication.vue?vue&type=script&lang=js&"
export * from "./my-account-setting-real-person-authentication.vue?vue&type=script&lang=js&"
import style0 from "./my-account-setting-real-person-authentication.vue?vue&type=style&index=0&id=7d0a972e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0a972e",
  null
  
)

export default component.exports